import { Component, Input, OnInit } from "@angular/core";
import { EnvironmentConfig } from "../../../core/core";
import { InspectionDefinition, InspectionSection, InspectionStep } from "../../models/inspection-definition.model";

declare const environment: EnvironmentConfig;

@Component({
  selector: "common-inspection-report",
  templateUrl: "./inspection-report.component.html",
  styleUrls: ["./inspection-report.component.scss"],
})
export class InspectionReportComponent implements OnInit {
  @Input() inspection: InspectionDefinition;

  baseImagePath = environment.baseImagePath;

  constructor() {}

  ngOnInit(): void {
    this.inspection.sections.forEach((section: InspectionSection) => {
      section.steps.forEach((step: InspectionStep) => {
        // if all step inputs are photos, we need to remove them
        step.hide = step.inputs.length && step.inputs.every(d => d.inputType === "Photo");
        step.hasNotes = step.inputs.filter(d => d.value != null).length != 0;
        section.hasFailures = section.hasFailures || (step.stepType == "BoolStep" && step.value != "True");
      });
    });
  }
}
